import { FileText } from "lucide-react";
import { Link } from "react-router-dom";
import type { RecentNote } from "../types";
import {
  Card,
  CardHeader,
  Empty,
  formatDateShort,
  SkeletonRow,
  ViewAllLink,
} from "./_shared";

type Props = {
  notes: RecentNote[];
  isLoading?: boolean;
};

export function RecentNotesWidget({ notes, isLoading }: Props) {
  return (
    <Card>
      <CardHeader
        icon={
          <FileText
            className="h-4 w-4 text-[hsl(215,25%,40%)]"
            strokeWidth={1.5}
          />
        }
        title="Recent Notes"
        count={notes.length}
        action={<ViewAllLink href="/notes" />}
      />
      {isLoading ? (
        <div>
          {[0, 1, 2].map((i) => (
            <SkeletonRow key={i} />
          ))}
        </div>
      ) : notes.length === 0 ? (
        <Empty
          icon={
            <FileText
              className="h-8 w-8 text-muted-foreground opacity-40"
              strokeWidth={1.5}
            />
          }
          text="No recent notes"
        />
      ) : (
        <ul className="space-y-2">
          {notes.slice(0, 3).map((n) => (
            <li key={n.id}>
              <Link
                to={`/notes/${n.id}`}
                className="flex items-center gap-2 rounded-md px-1 py-1.5 hover:bg-[hsl(210,50%,98%)]"
              >
                <div className="min-w-0 flex-1">
                  <div className="truncate text-[13px] font-medium text-foreground">
                    {n.title}
                  </div>
                  {n.code && (
                    <div className="truncate text-[10px] text-muted-foreground">
                      {n.code}
                    </div>
                  )}
                </div>
                <span className="shrink-0 text-[11px] text-muted-foreground">
                  {formatDateShort(n.createdAt)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
